import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Spinner } from 'components';
import { Layout } from 'modules/layout/containers';
import { RouteManager } from 'modules/router/containers';
import moment from 'moment';
import { PersistGate } from 'redux-persist/integration/react';
import { WalletConnectContext } from 'services';
import store from 'store/configureStore';
import { theme } from 'theme';

import 'moment/locale/ru';
import 'utils/i18n';

import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
moment.locale('ru');

root.render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <Router>
        <Suspense fallback={<Spinner size="xl" position="center" />}>
          <WalletConnectContext>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ru">
                <CssBaseline />
                <ToastContainer autoClose={4000} hideProgressBar position="bottom-right" closeButton />
                <Layout>
                  <RouteManager />
                </Layout>
              </LocalizationProvider>
            </ThemeProvider>
          </WalletConnectContext>
        </Suspense>
      </Router>
    </PersistGate>
  </Provider>,
);
